import { dateUtils } from '@festina-life/core'
import { useState } from 'react'

import { useTimes } from '../../hooks/useTimes'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import { TimeModal } from '../settings/TimeModal'
import { LabelWithWarning } from './LabelWithWarning'

type Props = {
  shouldAllowToChangeTime: boolean
}

export const TimeSettings = withLifeErrorBoundary(
  ({ shouldAllowToChangeTime }: Props) => {
    const { areComponentTimesAllEqual, componentTimes, time } = useTimes()
    const [isTimeModalOpen, setIsTimeModalOpen] = useState(false)

    return (
      <>
        <LabelWithWarning
          hasWarning={!areComponentTimesAllEqual}
          onClick={() => setIsTimeModalOpen(true)}
          data-testid="time-settings-label"
        >
          {dateUtils.dateAsStr(time)}
        </LabelWithWarning>
        {isTimeModalOpen && (
          <TimeModal
            availableTimes={componentTimes}
            onClose={() => setIsTimeModalOpen(false)}
            shouldAllowToChangeTime={shouldAllowToChangeTime}
          />
        )}
      </>
    )
  },
  {
    FallbackComponent: () => (
      <LabelWithWarning hasWarning>No time available</LabelWithWarning>
    ),
  },
)
